import React, { Component } from "react";
import { Router, HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { history } from './container/History';
import NotFound from './components/NotFound';
import AdminDashboard from './components/Dashboard/AdminDashboard';
import AlumniDashboard from './components/Dashboard/AlumniDashboard';
import AdminSearch from './components/QuickSearch/AdminSearch';
import AlumniSearch from './components/QuickSearch/AlumniSearch';
import AdvancedSearch from './components/QuickSearch/AdvancedSearch';
import PrivateAdminRoute from './components/HOC/PrivateAdminRoute';
import PrivateAlumniRoute from './components/HOC/PrivateAlumniRoute';
import ListandSearch from './components/ListandAdvancedSearch';
import RecordRepair from './components/RecordRepair';
import MyProfile from './components/MyProfile/myprofile';
import AlumniProfile from './components/AlumniProfile/Index';
import FAQPage from './components/FAQ';
import MaintainAlumni from './components/MaintainAlumni/index';
import AdminAuth from './components/HOC/AdminAuth';
import Loading from './components/HOC/loading';
import UnAuthorized from './components/UnAuthorized';
import PurchaseMembership from './components/Membership/PurchaseMembership';
import GiftMembership from './components/Membership/GiftMembership';
import Login from './components/Login/index'
import SAFSupport from './components/SAFSupport/index'
import Events from './components/Events/index'
import PendingMembership from './components/Membership/PendingMembership'
import ActivateMembership from './components/Membership/ActivateMembership'
import TermsandConditions from './components/Inc/TermsAndConditions'
import ManageMemberID from "./components/Inc/ManageMemberID";
import NeedHelp from './components/Inc/NeedHelp';
import RenewMembership from './components/Membership/RenewMembership';
import MultipleMembership from './components/Membership/MultipleMembership';
import NeedHelpAlumni from './components/AlumniHelp/NeedHelpAlumni';
import AlumniHelpReportIssue from './components/AlumniHelp/AlumniHelpReportIssue';
import AlumniHelpNST from './components/AlumniHelp/AlumniHelpNST';
import AlumniProgramSupport from './components/AlumniHelp/AlumniProgramSupport';
import PromoCodePortal from './components/PromoCode/PromoCode';
import AddPromoCode from './components/PromoCode/AddPromoCode';
import PrivacySettings from "./components/Inc/PrivacySettings";
import NESABulkUpload from './components/BulkUpload/alumni'
import AdminBulkUpload from './components/BulkUpload/admin'
import EditAlumniRecord from './components/RecordRepair/EditAlumniRecord';
import NewRoles from "./components/Inc/NewRoles";
import AddAlumniProfile from './components/RecordRepair/AddAlumniRecord';
import { refreshSession } from "./actions";
import { bindActionCreators } from "redux";
// import { Spin } from "bsa-ui";


class Root extends Component {
    componentDidMount() {
        if (localStorage.getItem('user') && localStorage.getItem('viaSso') === 'true') {
            // Re-validate the SSO session via /refresh on every full page load,
            // not just when landing on Login - so reloading a protected page
            // (e.g. the dashboard) after logging in also detects a session that
            // went bad on the other site. Only for sessions that actually came
            // from the other site (viaSso) - manual username/password login
            // never establishes an SSO session, so there's nothing for /refresh
            // to check there. Login handles the "no local session yet" cases
            // (SSO handoff, direct visit) separately.
            this.props.refreshSession(true);
        }
    }

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path="/" component={Login} exact />
                    <Route path="/nesa-bulk-upload" component={NESABulkUpload} exact />
                    <Route path="/manage-memberid" component={ManageMemberID} exact />
                    <Route path="/gift-membership" component={GiftMembership} exact />
                    <Route path="/renew-membership" component={RenewMembership} exact />
                    <Route path="/multiple-membership" component={MultipleMembership} exact />
                    <PrivateAdminRoute path="/bulk-upload" component={AdminAuth(AdminBulkUpload)} exact />
                    <PrivateAdminRoute path="/admin-dashboard" component={AdminDashboard} exact />
                    <PrivateAdminRoute path="/quick-search" component={AdminSearch} exact />
                    <Route path="/alumni-search" component={AlumniSearch} exact />
                    <PrivateAdminRoute path="/advanced-search" component={AdvancedSearch} exact />
                    <PrivateAdminRoute path="/list-and-search" component={ListandSearch} exact />
                    <PrivateAdminRoute path="/record-repair" component={RecordRepair} exact />
                    {/* <PrivateAdminRoute path="/record-repair-tool/:personGuid/editEagle" component={EditAlumniRecord} exact /> */}
                    <PrivateAdminRoute path="/gift-membership" component={GiftMembership} exact />
                    <PrivateAdminRoute path="/edit-alumnirecord" component={EditAlumniRecord} exact />
                    <PrivateAdminRoute path="/list-and-search/:preferencename/:listtype/:mode" component={ListandSearch} exact />
                    <PrivateAlumniRoute path="/alumni-dashboard" component={AlumniDashboard} exact />
                    <Route path="/purchase-membership" component={PurchaseMembership} exact />
                    <PrivateAlumniRoute path="/my-profile" component={MyProfile} exact />
                    <PrivateAlumniRoute path="/alumni-profile/:personGuid/:returnto" component={AlumniProfile} exact />
                    <PrivateAdminRoute path="/maintain-alumni/:personGuid/:returnto" component={MaintainAlumni} exact />
                    <PrivateAdminRoute path="/record-repair-tool/:personGuid/add-eagle" component={AddAlumniProfile} exact />
                    <PrivateAdminRoute path="/record-repair-tool/:personGuid/editEagle" component={EditAlumniRecord} exact />
                    <PrivateAlumniRoute path="/saf-support/" component={SAFSupport} exact />
                    <PrivateAlumniRoute path="/events" component={Events} exact />
                    <PrivateAlumniRoute path="/faq" component={FAQPage} exact />
                    <PrivateAdminRoute path="/pending-membership" component={PendingMembership} exact />
                    <PrivateAdminRoute path="/activate-membership/:registrationid" component={ActivateMembership} exact />
                    <PrivateAlumniRoute path="/terms-conditions" component={TermsandConditions} exact />
                    <PrivateAlumniRoute path='/need-help' component={NeedHelp} exact />
                    <PrivateAlumniRoute path='/privacy-setting' component={PrivacySettings} exact />
                    <PrivateAdminRoute path='/Promo-Code-Portal' component={PromoCodePortal} exact />
                    <PrivateAdminRoute path='/Add-Promo-Code-Portal' component={AddPromoCode} exact />
                    <PrivateAlumniRoute path="/need-help-alumni" component={NeedHelpAlumni} exact />
                    <PrivateAlumniRoute path="/need-help-alumni-report-issue" component={AlumniHelpReportIssue} exact />
                    <PrivateAlumniRoute path="/need-help-alumni-nst-portal" component={AlumniHelpNST} exact />
                    <PrivateAlumniRoute path="/need-help-alumni-program-support" component={AlumniProgramSupport} exact />
                    <PrivateAdminRoute path="/manage-roles" component={NewRoles} exact />
                    <Route path="/loading" component={Loading} exact />
                    <Route path="/unauthorized" component={UnAuthorized} exact />
                    <Route path="*" component={NotFound} exact />
                </Switch>
            </Router>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            refreshSession
        },
        dispatch
    );
}

export default connect(null, mapDispatchToProps)(Root);


// WEBPACK FOOTER //
// ./src/root.js